<template>
  <div>
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.marketInsight')">
    </NavHeaderBar>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="$t('tips.nothingMore')"
      @load="onLoad"
      class="item-list"
    >
      <div v-for="item in list" :key="item.id" class="item-card" @click="toUrl(item)">
        <div class="item-title van-ellipsis">{{ item.surveyName }}</div>
        <div class="item-footer">
          <span :class="['item-status', item.collectStatus === 1 ? 'status-collecting' : 'status-closed']">{{ item.collectStatus === 1 ? $t('shared.collecting') : item.collectStatus === 2 ? $t('shared.closed') : '' }}</span>
          <span class="item-deadline">{{ $t('shared.deadline') }}: {{ item.endTime }}</span>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { surveyAppListPageApi } from '@/api/marketInsight'
import { Toast } from 'vant'
export default {
  name: 'MarketInsight',
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  activated () {
    // When the component is activated (e.g., when returning from another page),
    // reset the list state to ensure data is reloaded from the first page
    // and to prevent data duplication.
    this.list = []
    this.page = 1
    this.finished = false
    this.loading = false
  },
  methods: {
    onLoad () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      surveyAppListPageApi({ page: this.page, limit: 10 }).then(res => {
        Toast.clear()
        this.list = [...this.list, ...res.data.list]
        this.loading = false

        // 数据全部加载完成
        if (this.list.length >= Number(res.data.totalRow)) {
          this.finished = true
        }
        this.page++
      }).catch(() => {})
    },
    toUrl (item) {
      this.$router.push(`/marketInsight/marketCreate?surveyId=${item.id}&collectStatus=${item.collectStatus}`)
    }
  }
}
</script>

<style lang="less" scoped>
.item-card {
  background: #fff;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;

  .item-title {
    font-size: 14px;
    color: #333;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .item-footer {
    display: flex;
    align-items: center;
    font-size: 12px;

    .item-status {
      padding: 2px 8px;
      margin-right: 10px;
    }

    .status-collecting {
      background-color: #d2f6d1;
      color: #0c9709;
      border: 1px solid #2a8a29;
    }

    .status-closed {
      background-color: #e6e6e6;
      color: #7f7f7f;
      border: 1px solid #aaaaaa;
    }
  }
}
</style>
